import { Show } from 'react-admin';
import { Link } from 'react-router-dom';
import { Box, Typography, Paper, Chip, Alert, Grid, Button } from '@mui/material';
import { Warning, Security, Event } from '@mui/icons-material';

export const CalendarView = () => (
  <Show render={({ record }) => {
    if (!record) return null;
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="info" sx={{ mb: 2 }} icon={<Event />}>
          OHS Calendar Event — {record.eventType}
        </Alert>
        <Grid container spacing={2} sx={{ mb: 3 }}>
          {[
            { label: 'Event', value: record.eventName, bold: true },
            { label: 'Date', value: record.eventDate },
            { label: 'Type', value: record.eventType },
            { label: 'Status', value: record.status, chip: true },
            { label: 'Location', value: record.location },
            { label: 'Attendees', value: record.attendees },
          ].map(f => (
            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={f.label}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="caption" color="text.secondary">{f.label}</Typography>
                {f.chip ? (
                  <Box sx={{ mt: 0.5 }}>
                    <Chip label={f.value} size="small" />
                  </Box>
                ) : (
                  <Typography variant="body1" sx={{ fontWeight: f.bold ? 700 : 400, mt: 0.5 }}>{f.value ?? '—'}</Typography>
                )}
              </Paper>
            </Grid>
          ))}
        </Grid>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button component={Link} to="/ohs-representatives" variant="outlined" size="small" startIcon={<Security />}>
            View Representatives
          </Button>
          <Button component={Link} to="/workplace-injuries" variant="outlined" size="small" startIcon={<Warning />}>
            View Incidents
          </Button>
        </Box>
      </Box>
    );
  }} />
);
